import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IconCustomControlComponent } from './icon-custom-control.component';
import { PlIconModule } from '@app/icon-library/lib/pl-icon.module';
import { ButtonModule } from '@app/components/button/button.module';

@NgModule({
  imports: [CommonModule, PlIconModule, ButtonModule],
  declarations: [IconCustomControlComponent],
  exports: [IconCustomControlComponent],
})
export class IconCustomControlModule {}
